"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.customization", ["nucont.shared"]);
require("./customization.routes");
